import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface ImageGridProps {
    selectedImages: { uri: string; id: string }[];
    handleImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
    removeImage: (id: string) => void;
}

const ImageGridContainer: React.FC<ImageGridProps> = ({ selectedImages, handleImageUpload, removeImage }) => {
    const theme = useTheme();
    return (
        <Box
            display="grid"
            gridTemplateColumns="repeat(3, 1fr)"
            flexWrap="wrap"
            justifyContent="center"
            gap={4}
            mb={2}
            mt={1}
        >
            {Array.from({ length: 6 }).map((_, index) => {
                const image = selectedImages[index];
                return (
                    <Box
                        key={index}
                        width={80}
                        height={80}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        border={`1px solid ${theme.palette.divider}`}
                        borderRadius="8px"
                        position="relative"
                        bgcolor={image ? "transparent" : theme.palette.background.paper}
                        sx={{ overflow: "hidden" }}
                    >
                        {image ? (
                            <>
                                <img
                                    src={image.uri}
                                    alt={`Uploaded ${index}`}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                                <Box
                                    position="absolute"
                                    top={4}
                                    right={4}
                                    sx={{
                                        backgroundColor: "rgba(0,0,0,0.5)",
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        width: 25,
                                        height: 25,
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                    onClick={() => removeImage(image.id)}
                                >
                                    <Typography
                                        sx={{
                                            color: "#fff",
                                            fontSize: 12,
                                            fontWeight: "bold",
                                        }}
                                    >
                                        <CloseIcon />
                                    </Typography>
                                </Box>
                            </>
                        ) : (
                            <label htmlFor={`image-upload-${index}`}>
                                {index === 0 ? (
                                    <img
                                        src="/images/UploadImage.svg"
                                        alt="UploadIcon"
                                        style={{ width: 40, height: 40 }}
                                    />
                                ) : (
                                    <img
                                        src="/images/PlusIcon.svg"
                                        alt="PlusIcon"
                                        style={{ width: 40, height: 40 }}
                                    />
                                )}
                                <input
                                    id={`image-upload-${index}`}
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={(event) => handleImageUpload(event)}
                                />
                            </label>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default ImageGridContainer;